import { render, staticRenderFns } from "./TabConcordancia.vue?vue&type=template&id=6526deb0&"
import script from "./TabConcordancia.vue?vue&type=script&lang=js&"
export * from "./TabConcordancia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports